import { Permissoes } from './permissoes';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class PermissoesService {

  constructor(private auth: AuthenticationService) { }


  validarPermissaoRota(rota) {
    if (this.rotaPerfilDeAcessoLiberadaParaUsusarioAdministrador(rota)) {
      return;
    }

    if (!this.auth.usuarioTemPermissaoNaRota(rota)) {
      throw new Error('Usuário sem permissão para acessar.');
    }
  }

  private rotaPerfilDeAcessoLiberadaParaUsusarioAdministrador(rota: any): boolean {
    return (this.eCadastroPerfilDeAcesso(rota) && this.auth.usuarioAdministrador());
  }

  private eCadastroPerfilDeAcesso(rota: any) {
    const rotaPesquisaPerfilAcesso = Permissoes.PESQUISA_PERFIL_ACESSO.getValor();
    const rotaCadastroPerfilAcesso = Permissoes.CADASTRO_PERFIL_ACESSO.getValor();
    return (rota === rotaPesquisaPerfilAcesso || rota === rotaCadastroPerfilAcesso);
  }
}
